"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.websocket = void 0;
const tslib_1 = require("tslib");
const ws_1 = tslib_1.__importDefault(require("ws"));
exports.websocket = typeof WebSocket !== "undefined" ? WebSocket : ws_1.default;
//# sourceMappingURL=websocket.js.map